import { FC } from 'react'

import MediaCard from './common/MediaCard'

type Props = {}

const WhoAreWeCard: FC<Props> = () => {
  return (
    <MediaCard
      image={{
        alt: 'Robot upper half with envelopes',
        desktop: {
          dimensions: {
            height: 599,
            width: 660,
          },
          src: '/images/new/robot-upperhalf-cut-aus.png',
        },
        mobile: {
          dimensions: {
            height: 544,
            width: 552,
          },
          src: '/images/new/robot-upperhalf-aus.png',
        },
      }}
      layout={{
        desktop: 'content-right-media-left',
        mobile: 'content-top-media-bottom',
      }}
      imageFitPreset='cover-right'
      imageContainerWidth='50%'
    >
      <div className='d-flex flex-1 flex-column gap-2 gap-lg-4 px-4 pt-8 pe-xxl-15 py-lg-40 ms-lg-n20 ms-xxl-n27'>
        <h2 className='fw-semibold fs-fluid-36-80 lh-105 mb-0'>Who we are</h2>
        <span className='fw-semibold lh-119 fs-fluid-18-28'>
          Established in the Hoxton area of central London in 2010, The Hoxton
          Mix is not your typical virtual office SaaS provider. With a passion
          for innovation and a drive to empower SMEs worldwide, we have become a
          leading name in the industry. We operate in central London, and
          Sydney, Australia.
        </span>
      </div>
    </MediaCard>
  )
}

export default WhoAreWeCard
